import { render, staticRenderFns } from "./DeleteShopUser.vue?vue&type=template&id=0c09b57c"
import script from "./DeleteShopUser.vue?vue&type=script&lang=js"
export * from "./DeleteShopUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports